import type { Event, EventHint } from "@sentry/types";

// Matches the gem constant `GraphQL::PersistedQueries::NotFound::MESSAGE` and the same string
// filtered from the toast path in errorLink. An APQ cache-miss is a normal client-retry handshake;
// when Apollo has already retried and the miss recurs it surfaces as an ApolloError, but it is
// still not actionable, so it must never reach Sentry.
const PERSISTED_QUERY_NOT_FOUND_MESSAGE = "PersistedQueryNotFound";

const persistedQueryNotFound = (event: Event, hint: EventHint): Event | null => {
  const error = hint.originalException as Error | string;

  const isPersistedQueryNotFoundString =
    typeof error === "string" && error.includes(PERSISTED_QUERY_NOT_FOUND_MESSAGE);
  const isPersistedQueryNotFoundError =
    typeof error !== "string" && error?.message?.includes(PERSISTED_QUERY_NOT_FOUND_MESSAGE);

  if (isPersistedQueryNotFoundString || isPersistedQueryNotFoundError) {
    return null;
  }

  return event;
};

export { persistedQueryNotFound };
